import React, { Component } from "react";
import BrowseActivities from "./browseActivities";
import ActivitiesSignups from "./activitiesSignups";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";

class Activities extends Component {
  render() {
    const intl = this.props.intl;
    return (
      <Tabs className="product__tabs">
        <TabList>
          <Tab>{intl.formatMessage(messages.upcomingDescription)}</Tab>
          <Tab>{intl.formatMessage(messages.signUpsDescription)}</Tab>
          <Tab>{intl.formatMessage(messages.completedDescription)}</Tab>
        </TabList>

        <TabPanel className="product__tab" id="browse-activities">
          <BrowseActivities {...this.props} />
        </TabPanel>
        <TabPanel className="product__tab" id="signed-up-activities">
          <ActivitiesSignups completedSignups={false} {...this.props} />
        </TabPanel>
        <TabPanel className="product__tab" id="completed-activities">
          <ActivitiesSignups completedSignups={true} {...this.props} />
        </TabPanel>
      </Tabs>
    );
  }
}

Activities.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Activities);



// WEBPACK FOOTER //
// ./components/wellness/activities/activities.jsx